import {useTransition} from '@logistics-frontend/blocks'
import {ServerError, useBaseErrorCatcher} from '@logistics-frontend/core/utils/network'
import {useParams} from 'react-router-dom'

import {fetchPhoneByVoiceForwarding} from 'src/api'
import {ForwardingId, Voiceforwarding} from 'src/api/types'

import {RouterParams} from '../../types'

type ForwardingProps = {
  forwardingID: ForwardingId
}
type PhoneProps = {
  phone: string
}

export const useVoiceForwarding = (props: ForwardingProps | PhoneProps) => {
  const {sharingKey = ''} = useParams<RouterParams>()
  const [{isPending, payload}, startTransition] = useTransition<Voiceforwarding, ServerError>(undefined, {
    key: 'route/voice-forwarding',
  })
  const errorCatcher = useBaseErrorCatcher()

  function fetchPhone(): Promise<Voiceforwarding> {
    if ('forwardingID' in props) {
      return fetchPhoneByVoiceForwarding({
        forwarding_id: props.forwardingID,
        key: sharingKey,
      })
    }

    return fetchPhoneByPhone(props.phone)
  }

  function voiceForwardingHandler() {
    startTransition(fetchPhone, {
      onError: errorCatcher,
      onCommit: payload => {
        if (payload) {
          const link = document.createElement('a')

          link.href = `tel:${payload.phone}${payload.ext ? `,,${payload.ext}` : ''}`
          link.click()
        }
      },
    })
  }

  return [{isPending, payload}, voiceForwardingHandler] as const
}

function fetchPhoneByPhone(phone: string): Promise<Voiceforwarding> {
  return Promise.resolve({
    phone,
  })
}
